// extracted by mini-css-extract-plugin
export default {"root":"GlobalErrorMessage_root__VWldy"};